import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Stack } from '@mui/material';
import HelpTooltip from '../../../components/HelpTooltip';

const NewFormModal = ({ open, newFormName, setNewFormName, onClose, onCreate }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Create New Form</DialogTitle>
    <DialogContent>
      <Stack direction="row" alignItems="center">
        <TextField
          autoFocus
          label="Form Name"
          value={newFormName}
          onChange={(e) => setNewFormName(e.target.value)}
          fullWidth
          sx={{ mt: 1 }}
        />
        <HelpTooltip title="Enter a unique name." />
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button onClick={onCreate} variant="contained">
        Create
      </Button>
    </DialogActions>
  </Dialog>
);

export default NewFormModal;